import { useEffect } from 'react';

export const useHandleSuccess = (
  isSuccess: boolean,
  successCallback?: () => void,
) => {
  useEffect(() => {
    isSuccess && successCallback && successCallback();
  }, [isSuccess]);
};